// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectNoResponse,
    ProviderCollectionPayment,
    ProviderCollectionPaymentSortType,
    ProviderCreateCollectionPaymentPayload,
    ProviderCreateCopayPaymentPayload,
    ProviderPaymentPlan,
    ProviderPaymentPlanSortType,
    SupportCollectionPayment,
    SupportCreateCollectionPaymentPayload,
    SupportCreatePaymentPlanPayload,
    SupportPaymentPlan,
    SupportPaymentPlanSortType,
    SupportRefundCollectionPaymentPayload,
    ProviderCreateCollectionPaymentPayloadToJSON,
    ProviderCreateCopayPaymentPayloadToJSON,
    SupportCreateCollectionPaymentPayloadToJSON,
    SupportCreatePaymentPlanPayloadToJSON,
    SupportRefundCollectionPaymentPayloadToJSON,
    ObjectNoResponseFromJSON,
    ProviderCollectionPaymentFromJSON,
    ProviderPaymentPlanFromJSON,
    SupportCollectionPaymentFromJSON,
    SupportPaymentPlanFromJSON,
} from '../models';

export interface DisableProviderCollectionPaymentPlanRequest {
    id: string;
}

export interface DisableSupportCollectionPaymentPlanRequest {
    id: string;
}

export interface GetProviderCollectionPaymentRequest {
    id: string;
}

export interface GetProviderCollectionPaymentPlanRequest {
    id: string;
}

export interface GetSupportCollectionPaymentRequest {
    id: string;
}

export interface GetSupportCollectionPaymentPlanRequest {
    id: string;
}

export interface ListProviderCollectionPaymentPlansRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderCollectionPaymentPlansOrderEnum>;
    filterCreated?: Array<string>;
    filterInvoiceId?: Array<string>;
    filterGuarantorId?: Array<string>;
    filterClaimId?: Array<string>;
    sort?: Array<ProviderPaymentPlanSortType>;
}

export interface ListProviderCollectionPaymentsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderCollectionPaymentsOrderEnum>;
    filterCreated?: Array<string>;
    filterClaimId?: Array<string>;
    filterGuarantorId?: Array<string>;
    filterClaimType?: ListProviderCollectionPaymentsFilterClaimTypeEnum;
    sort?: Array<ProviderCollectionPaymentSortType>;
}

export interface ListSupportCollectionPaymentPlansRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportCollectionPaymentPlansOrderEnum>;
    filterCreated?: Array<string>;
    filterClaimId?: Array<string>;
    filterGuarantorId?: Array<string>;
    sort?: Array<SupportPaymentPlanSortType>;
}

export interface ListSupportCollectionPaymentsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportCollectionPaymentsOrderEnum>;
    filterCreated?: Array<string>;
    filterClaimId?: Array<string>;
    filterGuarantorId?: Array<string>;
    filterClaimType?: ListSupportCollectionPaymentsFilterClaimTypeEnum;
    sort?: Array<ProviderCollectionPaymentSortType>;
}

export interface PostProviderCollectionPaymentRefundRequest {
    id: string;
    supportRefundCollectionPaymentPayload: SupportRefundCollectionPaymentPayload;
}

export interface PostProviderCreateCollectionPaymentRequest {
    providerCreateCollectionPaymentPayload: ProviderCreateCollectionPaymentPayload;
}

export interface PostProviderCreateCopayPaymentRequest {
    providerCreateCopayPaymentPayload: ProviderCreateCopayPaymentPayload;
}

export interface PostProviderPaymentPlanRequest {
    supportCreatePaymentPlanPayload: SupportCreatePaymentPlanPayload;
}

export interface PostSupportCollectionPaymentDisableRequest {
    id: string;
}

export interface PostSupportCollectionPaymentRefundRequest {
    id: string;
    supportRefundCollectionPaymentPayload: SupportRefundCollectionPaymentPayload;
}

export interface PostSupportCreateCollectionPaymentRequest {
    supportCreateCollectionPaymentPayload: SupportCreateCollectionPaymentPayload;
}

export interface PostSupportPaymentPlanRequest {
    supportCreatePaymentPlanPayload: SupportCreatePaymentPlanPayload;
}

/**
 * no description
 */
export class CollectionApi extends runtime.BaseAPI {

    /**
     * Disable a payment plan
     * Disable the payment plan
     */
    async disableProviderCollectionPaymentPlanRaw(requestParameters: DisableProviderCollectionPaymentPlanRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableProviderCollectionPaymentPlan.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:invoice"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/plan/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable a payment plan
     * Disable the payment plan
     */
    async disableProviderCollectionPaymentPlan(requestParameters: DisableProviderCollectionPaymentPlanRequest): Promise<ObjectNoResponse> {
        const response = await this.disableProviderCollectionPaymentPlanRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a payment plan
     * Disable the payment plan
     */
    async disableSupportCollectionPaymentPlanRaw(requestParameters: DisableSupportCollectionPaymentPlanRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportCollectionPaymentPlan.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:invoice", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/plan/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable a payment plan
     * Disable the payment plan
     */
    async disableSupportCollectionPaymentPlan(requestParameters: DisableSupportCollectionPaymentPlanRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportCollectionPaymentPlanRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get collection payment by id
     * Get collection payment by id
     */
    async getProviderCollectionPaymentRaw(requestParameters: GetProviderCollectionPaymentRequest): Promise<runtime.ApiResponse<ProviderCollectionPayment>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderCollectionPayment.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/payment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderCollectionPaymentFromJSON(jsonValue));
    }

    /**
     * Get collection payment by id
     * Get collection payment by id
     */
    async getProviderCollectionPayment(requestParameters: GetProviderCollectionPaymentRequest): Promise<ProviderCollectionPayment> {
        const response = await this.getProviderCollectionPaymentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get collection payment plan by id
     * Get collection payment plan by id
     */
    async getProviderCollectionPaymentPlanRaw(requestParameters: GetProviderCollectionPaymentPlanRequest): Promise<runtime.ApiResponse<ProviderPaymentPlan>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderCollectionPaymentPlan.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/plan/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderPaymentPlanFromJSON(jsonValue));
    }

    /**
     * Get collection payment plan by id
     * Get collection payment plan by id
     */
    async getProviderCollectionPaymentPlan(requestParameters: GetProviderCollectionPaymentPlanRequest): Promise<ProviderPaymentPlan> {
        const response = await this.getProviderCollectionPaymentPlanRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get collection payment by id
     * Get collection payment by id
     */
    async getSupportCollectionPaymentRaw(requestParameters: GetSupportCollectionPaymentRequest): Promise<runtime.ApiResponse<SupportCollectionPayment>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportCollectionPayment.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/payment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportCollectionPaymentFromJSON(jsonValue));
    }

    /**
     * Get collection payment by id
     * Get collection payment by id
     */
    async getSupportCollectionPayment(requestParameters: GetSupportCollectionPaymentRequest): Promise<SupportCollectionPayment> {
        const response = await this.getSupportCollectionPaymentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get collection payment by id
     * Get collection payment by id
     */
    async getSupportCollectionPaymentPlanRaw(requestParameters: GetSupportCollectionPaymentPlanRequest): Promise<runtime.ApiResponse<SupportPaymentPlan>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportCollectionPaymentPlan.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/plan/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportPaymentPlanFromJSON(jsonValue));
    }

    /**
     * Get collection payment by id
     * Get collection payment by id
     */
    async getSupportCollectionPaymentPlan(requestParameters: GetSupportCollectionPaymentPlanRequest): Promise<SupportPaymentPlan> {
        const response = await this.getSupportCollectionPaymentPlanRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of collection payment plans
     * Get a list of collection payment plans
     */
    async listProviderCollectionPaymentPlansRaw(requestParameters: ListProviderCollectionPaymentPlansRequest): Promise<runtime.ApiResponse<Array<ProviderPaymentPlan>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterInvoiceId) {
            queryParameters['filterInvoiceId'] = requestParameters.filterInvoiceId;
        }

        if (requestParameters.filterGuarantorId) {
            queryParameters['filterGuarantorId'] = requestParameters.filterGuarantorId;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/plan`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderPaymentPlanFromJSON));
    }

    /**
     * Gets a list of collection payment plans
     * Get a list of collection payment plans
     */
    async listProviderCollectionPaymentPlans(requestParameters: ListProviderCollectionPaymentPlansRequest): Promise<Array<ProviderPaymentPlan>> {
        const response = await this.listProviderCollectionPaymentPlansRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of collection payments
     * Get a list of collection payments
     */
    async listProviderCollectionPaymentsRaw(requestParameters: ListProviderCollectionPaymentsRequest): Promise<runtime.ApiResponse<Array<ProviderCollectionPayment>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterGuarantorId) {
            queryParameters['filterGuarantorId'] = requestParameters.filterGuarantorId;
        }

        if (requestParameters.filterClaimType !== undefined) {
            queryParameters['filterClaimType'] = requestParameters.filterClaimType;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/payment`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderCollectionPaymentFromJSON));
    }

    /**
     * Gets a list of collection payments
     * Get a list of collection payments
     */
    async listProviderCollectionPayments(requestParameters: ListProviderCollectionPaymentsRequest): Promise<Array<ProviderCollectionPayment>> {
        const response = await this.listProviderCollectionPaymentsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of collection payments
     * Get a list of collection payments
     */
    async listSupportCollectionPaymentPlansRaw(requestParameters: ListSupportCollectionPaymentPlansRequest): Promise<runtime.ApiResponse<Array<SupportPaymentPlan>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterGuarantorId) {
            queryParameters['filterGuarantorId'] = requestParameters.filterGuarantorId;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/plan`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportPaymentPlanFromJSON));
    }

    /**
     * Gets a list of collection payments
     * Get a list of collection payments
     */
    async listSupportCollectionPaymentPlans(requestParameters: ListSupportCollectionPaymentPlansRequest): Promise<Array<SupportPaymentPlan>> {
        const response = await this.listSupportCollectionPaymentPlansRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of collection payments
     * Get a list of collection payments
     */
    async listSupportCollectionPaymentsRaw(requestParameters: ListSupportCollectionPaymentsRequest): Promise<runtime.ApiResponse<Array<SupportCollectionPayment>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterGuarantorId) {
            queryParameters['filterGuarantorId'] = requestParameters.filterGuarantorId;
        }

        if (requestParameters.filterClaimType !== undefined) {
            queryParameters['filterClaimType'] = requestParameters.filterClaimType;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/payment`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportCollectionPaymentFromJSON));
    }

    /**
     * Gets a list of collection payments
     * Get a list of collection payments
     */
    async listSupportCollectionPayments(requestParameters: ListSupportCollectionPaymentsRequest): Promise<Array<SupportCollectionPayment>> {
        const response = await this.listSupportCollectionPaymentsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Refresh stripe
     * Refresh stripe
     */
    async postCollectionActionRefreshStripeRaw(): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:invoice", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/actions/refresh_stripe`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Refresh stripe
     * Refresh stripe
     */
    async postCollectionActionRefreshStripe(): Promise<ObjectNoResponse> {
        const response = await this.postCollectionActionRefreshStripeRaw();
        return await response.value();
    }

    /**
     * Refund collection payment
     * Refund collection payment
     */
    async postProviderCollectionPaymentRefundRaw(requestParameters: PostProviderCollectionPaymentRefundRequest): Promise<runtime.ApiResponse<ProviderCollectionPayment>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postProviderCollectionPaymentRefund.');
        }

        if (requestParameters['supportRefundCollectionPaymentPayload'] === null || requestParameters['supportRefundCollectionPaymentPayload'] === undefined) {
            throw new runtime.RequiredError('supportRefundCollectionPaymentPayload','Required parameter requestParameters.supportRefundCollectionPaymentPayload was null or undefined when calling postProviderCollectionPaymentRefund.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/payment/{id}/refund`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportRefundCollectionPaymentPayloadToJSON(requestParameters['supportRefundCollectionPaymentPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderCollectionPaymentFromJSON(jsonValue));
    }

    /**
     * Refund collection payment
     * Refund collection payment
     */
    async postProviderCollectionPaymentRefund(requestParameters: PostProviderCollectionPaymentRefundRequest): Promise<ProviderCollectionPayment> {
        const response = await this.postProviderCollectionPaymentRefundRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create collection payment
     * Create collection payment
     */
    async postProviderCreateCollectionPaymentRaw(requestParameters: PostProviderCreateCollectionPaymentRequest): Promise<runtime.ApiResponse<ProviderCollectionPayment>> {
        if (requestParameters['providerCreateCollectionPaymentPayload'] === null || requestParameters['providerCreateCollectionPaymentPayload'] === undefined) {
            throw new runtime.RequiredError('providerCreateCollectionPaymentPayload','Required parameter requestParameters.providerCreateCollectionPaymentPayload was null or undefined when calling postProviderCreateCollectionPayment.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/payment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreateCollectionPaymentPayloadToJSON(requestParameters['providerCreateCollectionPaymentPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderCollectionPaymentFromJSON(jsonValue));
    }

    /**
     * Create collection payment
     * Create collection payment
     */
    async postProviderCreateCollectionPayment(requestParameters: PostProviderCreateCollectionPaymentRequest): Promise<ProviderCollectionPayment> {
        const response = await this.postProviderCreateCollectionPaymentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a copay payment
     * Create a copay payment
     */
    async postProviderCreateCopayPaymentRaw(requestParameters: PostProviderCreateCopayPaymentRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['providerCreateCopayPaymentPayload'] === null || requestParameters['providerCreateCopayPaymentPayload'] === undefined) {
            throw new runtime.RequiredError('providerCreateCopayPaymentPayload','Required parameter requestParameters.providerCreateCopayPaymentPayload was null or undefined when calling postProviderCreateCopayPayment.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/copay`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreateCopayPaymentPayloadToJSON(requestParameters['providerCreateCopayPaymentPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Create a copay payment
     * Create a copay payment
     */
    async postProviderCreateCopayPayment(requestParameters: PostProviderCreateCopayPaymentRequest): Promise<ObjectNoResponse> {
        const response = await this.postProviderCreateCopayPaymentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Generate payment plan
     * Generate payment plan
     */
    async postProviderPaymentPlanRaw(requestParameters: PostProviderPaymentPlanRequest): Promise<runtime.ApiResponse<ProviderPaymentPlan>> {
        if (requestParameters['supportCreatePaymentPlanPayload'] === null || requestParameters['supportCreatePaymentPlanPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreatePaymentPlanPayload','Required parameter requestParameters.supportCreatePaymentPlanPayload was null or undefined when calling postProviderPaymentPlan.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/plan`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreatePaymentPlanPayloadToJSON(requestParameters['supportCreatePaymentPlanPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderPaymentPlanFromJSON(jsonValue));
    }

    /**
     * Generate payment plan
     * Generate payment plan
     */
    async postProviderPaymentPlan(requestParameters: PostProviderPaymentPlanRequest): Promise<ProviderPaymentPlan> {
        const response = await this.postProviderPaymentPlanRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable collection payment
     * Disable collection payment
     */
    async postSupportCollectionPaymentDisableRaw(requestParameters: PostSupportCollectionPaymentDisableRequest): Promise<runtime.ApiResponse<SupportCollectionPayment>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportCollectionPaymentDisable.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payment", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/payment/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportCollectionPaymentFromJSON(jsonValue));
    }

    /**
     * Disable collection payment
     * Disable collection payment
     */
    async postSupportCollectionPaymentDisable(requestParameters: PostSupportCollectionPaymentDisableRequest): Promise<SupportCollectionPayment> {
        const response = await this.postSupportCollectionPaymentDisableRaw(requestParameters);
        return await response.value();
    }

    /**
     * Refund collection payment
     * Refund collection payment
     */
    async postSupportCollectionPaymentRefundRaw(requestParameters: PostSupportCollectionPaymentRefundRequest): Promise<runtime.ApiResponse<SupportCollectionPayment>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportCollectionPaymentRefund.');
        }

        if (requestParameters['supportRefundCollectionPaymentPayload'] === null || requestParameters['supportRefundCollectionPaymentPayload'] === undefined) {
            throw new runtime.RequiredError('supportRefundCollectionPaymentPayload','Required parameter requestParameters.supportRefundCollectionPaymentPayload was null or undefined when calling postSupportCollectionPaymentRefund.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payment", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/payment/{id}/refund`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportRefundCollectionPaymentPayloadToJSON(requestParameters['supportRefundCollectionPaymentPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportCollectionPaymentFromJSON(jsonValue));
    }

    /**
     * Refund collection payment
     * Refund collection payment
     */
    async postSupportCollectionPaymentRefund(requestParameters: PostSupportCollectionPaymentRefundRequest): Promise<SupportCollectionPayment> {
        const response = await this.postSupportCollectionPaymentRefundRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create collection payment
     * Create collection payment
     */
    async postSupportCreateCollectionPaymentRaw(requestParameters: PostSupportCreateCollectionPaymentRequest): Promise<runtime.ApiResponse<SupportCollectionPayment>> {
        if (requestParameters['supportCreateCollectionPaymentPayload'] === null || requestParameters['supportCreateCollectionPaymentPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateCollectionPaymentPayload','Required parameter requestParameters.supportCreateCollectionPaymentPayload was null or undefined when calling postSupportCreateCollectionPayment.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payment", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/payment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateCollectionPaymentPayloadToJSON(requestParameters['supportCreateCollectionPaymentPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportCollectionPaymentFromJSON(jsonValue));
    }

    /**
     * Create collection payment
     * Create collection payment
     */
    async postSupportCreateCollectionPayment(requestParameters: PostSupportCreateCollectionPaymentRequest): Promise<SupportCollectionPayment> {
        const response = await this.postSupportCreateCollectionPaymentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Generate payment plan
     * Generate payment plan
     */
    async postSupportPaymentPlanRaw(requestParameters: PostSupportPaymentPlanRequest): Promise<runtime.ApiResponse<SupportPaymentPlan>> {
        if (requestParameters['supportCreatePaymentPlanPayload'] === null || requestParameters['supportCreatePaymentPlanPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreatePaymentPlanPayload','Required parameter requestParameters.supportCreatePaymentPlanPayload was null or undefined when calling postSupportPaymentPlan.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payment", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/plan`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreatePaymentPlanPayloadToJSON(requestParameters['supportCreatePaymentPlanPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportPaymentPlanFromJSON(jsonValue));
    }

    /**
     * Generate payment plan
     * Generate payment plan
     */
    async postSupportPaymentPlan(requestParameters: PostSupportPaymentPlanRequest): Promise<SupportPaymentPlan> {
        const response = await this.postSupportPaymentPlanRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderCollectionPaymentPlansOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderCollectionPaymentsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderCollectionPaymentsFilterClaimTypeEnum {
    PROFESSIONAL = 'PROFESSIONAL',
    INSTITUTIONAL = 'INSTITUTIONAL',
    DENTAL = 'DENTAL',
    NYNF3 = 'NYNF3'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportCollectionPaymentPlansOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportCollectionPaymentsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportCollectionPaymentsFilterClaimTypeEnum {
    PROFESSIONAL = 'PROFESSIONAL',
    INSTITUTIONAL = 'INSTITUTIONAL',
    DENTAL = 'DENTAL',
    NYNF3 = 'NYNF3'
}
